import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API from '../apiConfig';

function Login({ setIsLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
      const token = localStorage.getItem('token');
      if (!!token){
        navigate('/profile');
      }
      
      //setIsLoggedIn(!!token); 
      
   
    }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(API.auth.login, { email, password });
      localStorage.setItem('token', response.data.token);
      setIsLoggedIn(true);
      setMessage('Login successful');
      navigate('/profile');
    } catch (error) {
      setMessage('Login failed: ');
      //+ error.response.data.message
    }
  };

  return (
    <div className="container-fluid bg-light min-vh-100 d-flex">
      <div className="row w-100 justify-content-center">
        <div className="col-md-9 col-lg-9">
          <div className="card shadow-lg border-0 rounded-lg mt-5">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-md-8 border-end">
                  <h2 className="text-center text-primary mb-4">Selamat Datang di MedikaHub</h2>
                  <p className="text-center text-muted mb-4">Aplikasi kesehatan terpercaya untuk kebutuhan medis Anda</p>
                  <ul className="list-unstyled">
                    <li className="mb-3"><i className="fas fa-user-md text-primary me-2"></i> Kelola data FKTP anda</li>
                    <li className="mb-3"><i className="fas fa-pills text-primary me-2"></i> Integrasi dengan segala sistem internal</li>
                    <li className="mb-3"><i className="fas fa-hospital text-primary me-2"></i> Tingkatkan pelayanan kepada pasien</li>
                  </ul>
                  <p className="text-center mt-4 fst-italic">Bergabunglah dengan MedikaHub untuk pengalaman kesehatan yang lebih baik!</p>
                </div>
                <div className="col-md-4">
                  <h3 className="text-center mb-4">Login</h3>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email:</label>
                      <input
                        className="form-control"
                        type="email"
                        id="email"
                        value={email}
                        autoFocus
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Password:</label>
                      <input
                        className="form-control"
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">Login</button>
                    </div>
                  </form>
                  {message && <p className="mt-3 text-center text-danger">{message}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
